export default {"src":"/_next/static/media/bookmark.c3ca2072.svg","height":20,"width":20,"blurWidth":0,"blurHeight":0};